import React from "react";
import {
  Headphones,
  UserCog,
  Wrench,
  ClipboardList,
  MessageSquareHeart,
} from "lucide-react";

import panIndiaImg from "../../assets/panIndia.png";

const supportItems = [
  {
    icon: Headphones,
    title: "Service & Support",
    text: "At Veyonta Track Technology, we provide reliable GPS support backed by experienced engineers and nationwide assistance whenever you need it.",
  },
  {
    icon: UserCog,
    title: "Dedicated and Smart Network of Engineers",
    text: "Our strategically located engineers ensure prompt assistance across metro cities and remote areas alike.",
  },
  {
    icon: Wrench,
    title: "On-Site Customer Support",
    text: "Our experts visit your location to resolve issues quickly, minimizing downtime and ensuring smooth operations.",
  },
  {
    icon: ClipboardList,
    title: "After-sales Online Service Request Portal",
    text: "Raise service requests easily and receive timely support through our dedicated after-sales portal.",
  },
  {
    icon: MessageSquareHeart,
    title: "Regular Feedback from Client Relationship Managers",
    text: "We continuously gather feedback to improve our services and maintain long-term customer satisfaction.",
  },
];

export default function PanIndiaSupportSection() {
  return (
    <section className="bg-white py-10 sm:py-12 lg:py-16">
      <div className="mx-auto grid max-w-[1280px] items-center gap-8 px-6 lg:grid-cols-2 lg:gap-12">

        {/* Left Container */}
        <div className="flex flex-col items-center lg:items-start">
          <h2 className="text-center text-35xl font-bold leading-tight text-[#111] sm:text-5xl lg:text-left">
            PAN India
            <br className="hidden lg:block" /> Service & Support
          </h2>

          {/* Scaled down the image slightly to save vertical space */}
          <img
            src={panIndiaImg}
            alt="Pan India Support"
            className="mt-6 w-full max-w-[300px] object-cover sm:mt-8 sm:max-w-[360px] lg:max-w-[400px]"
          />
        </div>

        {/* Right Container with reduced padding inside */}
        <div className="mt-8 rounded-2xl border border-[#df8a2d] bg-white p-5 shadow-sm sm:p-8 lg:mt-0 lg:p-10">
          
          {/* Drastically reduced the space-y gap between items */}
          <div className="space-y-6 sm:space-y-7">
            {supportItems.map((item) => {
              const Icon = item.icon;

              return (
                <div key={item.title} className="flex flex-col gap-3 sm:flex-row sm:gap-4">
                  
                  {/* Icon Container */}
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#df8b2d]/10 sm:h-12 sm:w-12">
                    <Icon size={20} className="text-[#df8b2d] sm:h-6 sm:w-6" />
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-[#222] sm:text-xl">
                      {item.title}
                    </h3>
                    {/* Tighter line-height and top margin for the text */}
                    <p className="mt-1 text-[15px] leading-[1.6] text-gray-600 sm:text-base">
                      {item.text}
                    </p>
                  </div>
                  
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
}